import clsx from 'clsx';
import React from 'react';

import {
  alignmentValues,
  backgroundColorValues,
  fontFamilyValues,
  fontSizeValues,
  gridValues,
  isFlex,
  marginValues,
  paddingValues,
  verticalAlignmentValues,
} from './constants';

function SectionBlock({ config, children }) {
  return (
    <section
      className={clsx(
        'section-block mt-24 [&>.section-block]:px-24',
        config?.wrap ? 'flex-wrap' : 'flex-nowrap',
        config?.css_classes,
        alignmentValues[config?.alignment],
        backgroundColorValues[config?.background_color],
        backgroundColorValues[config?.background_color] &&
          'p-20 *:first-of-type:mt-0 *:first-of-type:pt-0',
        fontFamilyValues[config?.font_family],
        fontSizeValues[config?.font_size],
        marginValues[config?.margin],
        paddingValues[config?.padding],
        gridValues[config?.layout],
        isFlex(config?.grid) && verticalAlignmentValues[config?.vertical]
      )}
    >
      {children}
    </section>
  );
}

export default SectionBlock;
